import React from 'react';
import {ThemeProvider} from '@rn-vui/themed';
import {observer} from 'mobx-react-lite';

import PhoneOrEmailVerification from '../../../components/PhoneOrEmailVerification';
import {AppRoute} from '../../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../../models/navigationTypes';
import {useStores} from '../../../stores/use-stores';
import rewardsTheme from '../../../theme/rewardsTheme';
import apiService from '../../../transport/apiService';

const AccountEmailVerificationScreen = observer(
  ({navigation}: RouteNavigatorScreenProps<AppRoute.ACCOUNT_EMAIL_VERIFICATION>) => {
    const {userStore} = useStores();
    return (
      <ThemeProvider theme={rewardsTheme}>
        <PhoneOrEmailVerification
          type="email"
          emailAddress={userStore.emailAddress}
          onSubmit={async (values, {setError}) => {
            const verifiedEmailSuccess = await userStore.verifyUserEmail(values.verification);

            if (verifiedEmailSuccess) {
              navigation.navigate(AppRoute.ROOT, {
                screen: AppRoute.MAIN,
                params: {screen: AppRoute.HOME},
              });
            } else {
              setError('verification', {
                type: 'manual',
                message: 'Wrong code entered. Please try again.',
              });
            }
          }}
          onResend={async () => {
            const result = await apiService.rewardsVerifyExistingUserEmail({
              emailAddress: userStore.emailAddress,
            });

            return !!result;
          }}
          onBack={() => {
            if (navigation.canGoBack()) {
              navigation.goBack();
            } else {
              navigation.navigate(AppRoute.ROOT, {
                screen: AppRoute.MAIN,
                params: {screen: AppRoute.HOME},
              });
            }
          }}
        />
      </ThemeProvider>
    );
  },
);

export default AccountEmailVerificationScreen;
